import { Cycle } from '../../../store/models/cycles';

const filterCyclesByContract = (cycles: Cycle[], contractId: string): Cycle[] => {
  return cycles.filter((cycle) => cycle.contractId === contractId);
}

export default filterCyclesByContract;
